module.exports = __webpack_public_path__ + "media/Mosquito.613fb605.ogg";